
import Vue from 'vue';
import {OrderInterface} from "~/store/order";
import ChefCard from "~/components/index/chef-highlight/chef-card.vue";

export default Vue.extend({
  name: 'OrderPayPage',
  components: {ChefCard},
  head: {
    title: 'Reserveringsdetails - CHEFSTBL',
  },
  data(): { order: OrderInterface | null } {
    return {
      order: null
    }
  },
  async fetch() {
    const id = this.$route.params.id
    const key = this.$route.query.key

    this.order = await this.$axios.$get<{ data: OrderInterface }>(`/v1/order/checkout/${id}/${key}`).then(data => data.data);
  },
  computed: {
    arrangement(): string {
      if (this.order) {
        const listing = this.order.listing;

        // Lame way to find first arrangement name and strip listing.title from it
        const itemNames = this.order.items.filter(orderItem => orderItem.type === 'arrangement').map(orderItem => orderItem.name);
        if (itemNames.length) {
          let itemName = itemNames[0];
          return itemName.replace(listing.title + ' |', '');
        }

        // Fallback
        return listing.subtitle;
      }

      return '';
    }
  }
})
